import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as PropTypes from 'prop-types';
import {
    Navbar,
    NavbarNavigationBar,
    NavbarAdditionalItems,
    NavbarUserMenu,
    NavbarHelpLink
} from '@lwt-helix/navbar';

import { PermissionCategories } from '../../constants/Enums';
import Routes from '../../constants/Routes';
import { UserHasPermission } from '../../functions/AuthorizationFunctions';
import { setStateData } from '../common/StateHelper';
import { getClaimsFromToken, getToken } from '../../functions/AuthenticationFunctions';

const NavBar = props => {
    const { location } = props;
    const permissions = useSelector(state => state.authorizationReducer.permissions);
    const userClients = useSelector(state => state.authenticationReducer.userClients);

    const [state, setState] = useState(
        {
            lwtClaims: getClaimsFromToken(getToken()),
            isReady: false,
            location: {
                pathname: Routes.LANDING_PAGE
            }
        }
    );

    useEffect(() => {
        setStateData('isReady', !!state.lwtClaims?.cid, setState);
    }, []);

    useEffect(() => {
        const userItems = [];
        const items = [];

        if (shouldDisplayItems() && getToken()) {
            if (UserHasPermission(permissions, PermissionCategories.USERS)) {
                items.push({
                    url: Routes.USERS,
                    icon: 'assignment_ind',
                    label: 'Users'
                });
            }
            if (UserHasPermission(permissions, PermissionCategories.ROLES)) {
                items.push({
                    url: Routes.SECURITY_GROUPS,
                    icon: 'view_list',
                    label: 'Security Groups'
                });
            }

            userItems.push({
                url: Routes.USER_SETTINGS,
                label: 'My Settings'
            });

            if ((userClients?.length ?? 0) > 1) {
                userItems.push({
                    url: Routes.CLIENT_SELECT,
                    icon: '',
                    label: 'Switch Client'
                });
            }
            userItems.push({
                icon: '',
                url: Routes.LOGOUT,
                label: 'Sign out'
            });

            setState(prevState => {
                const nextState = { ...prevState };
                nextState.items = items;
                nextState.userItems = userItems;
                nextState.isReady = !!state.lwtClaims?.cid;
                return nextState;
            });
        }
    }, [
        permissions,
        userClients
    ]);

    const shouldDisplayItems = () => {
        let currentPath = location.pathname;
        if (!currentPath)
            return true;
        let routePathSegments = currentPath.split('/', 3);
        let routeValues = Object.values(Routes.REGISTRATION);
        let shouldDisplay = true;
        for (let i = 0; i < routeValues.length; i++) {
            let registrationPathSegments = routeValues[i].split('/', 3);
            if (registrationPathSegments[1] === routePathSegments[1]
                && registrationPathSegments[2] === routePathSegments[2]
            ) {
                shouldDisplay = false;
                break;
            }
        }
        return shouldDisplay;
    };

    return (
        state.isReady && <Navbar dataLwtId="home-ui-nav" applicationName="Lone Wolf Home">
            <NavbarNavigationBar location={{ pathname: window.location.pathname }} navItems={state.items}/>
            <NavbarAdditionalItems>
                <NavbarHelpLink url="https://www.lwolf.com/support" target="_new" />
                <NavbarUserMenu menuItems={state.userItems}/>
            </NavbarAdditionalItems>
        </Navbar>
    );
};

NavBar.propTypes = {
    location: PropTypes.object.isRequired
};

export default withRouter(NavBar);
